
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel
} from "@/components/ui/form"
import { Input } from "@/components/ui/input";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { Checkbox } from "@/components/ui/checkbox";


import { Loader2, RefreshCw, Trash2 } from "lucide-react";
import { useApiFetch } from "@/helper/apiFetch";
import { Toggle } from "../ui/toggle";
import { TextChatInfoSchema, TextChatSchema } from "./TextChatSchema";
type TextChatInfoProps = {
  chat?: TextChatInfoSchema;
  eventId: string;
  onError?: (message: string) => void;
  onClose: (refresh: boolean) => void;
};






export function TextChatInfo({ chat, eventId,  onError ,onClose}: TextChatInfoProps) {
  const apiFetch = useApiFetch();
  const [errorText, setError] = useState("");
const [isGeneratingPasswordField, setIsGeneratingPasswordField] = useState<boolean>(false);
  const getParsedFormValues = () => {
    const parsed = TextChatSchema.safeParse({
      ...chat,
      EventId: chat?.EventId ?? eventId,
    });

    if (parsed.success) {
      return parsed.data;
    }

    return { EventId: eventId };
  };

  


  const form = useForm<z.infer<typeof TextChatSchema>>({
    resolver: zodResolver(TextChatSchema),
    defaultValues: getParsedFormValues()
  });

  useEffect(() => {
    form.reset(getParsedFormValues());
  }, [chat, eventId]);




  const onSubmit = async (values: z.infer<typeof TextChatSchema>) => {
    Save(values, true);
  }
  const Save = async (values: z.infer<typeof TextChatSchema>, closeAfterSave: boolean) => {
try {
      setError("");

      const isNew = !values.Id || values.Id <= 0;
     const fd = new FormData();
    
     if(!isNew)
      fd.append("key", values.Id ? values.Id.toString() : "0");
      fd.append("values", JSON.stringify(values));


      const res = await apiFetch(`/api/eventpool/${isNew?"PostNewChatRoom":"PutChatRoom"}`, { method: isNew?"POST":"PUT", body: fd });


      if (!res.ok) {
        const e = await res.text();
        setError( e);

      }
      else {

       

       
          onClose( true);
        

      }
    } catch (err) {
      console.error(err);
    }
  }

 
  const handleGeneratePassword = async () => {
    try {
      setIsGeneratingPasswordField(true);

   
     
        const res = await apiFetch('/api/eventpool/GenerateRandomPassword');
       
      

      if (!res.ok) {
        if(onError)
        onError("Failed to generate password");
        return;
      }

      const rawText = await res.text();
      const generatedPassword = rawText.startsWith('"') ? JSON.parse(rawText) : rawText.trim();
      if (!generatedPassword) {
        if(onError)
        onError("Password generation returned no value");
        return;
      }

      form.setValue("AccessCode", generatedPassword, { shouldDirty: true, shouldTouch: true, shouldValidate: true });
    } catch (err) {
      console.error(err);
      if(onError)
        onError("Failed to generate password");
    } finally {
      setIsGeneratingPasswordField(false);
    }
  };




  return (
    <div className="p-5">
   
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit, (error) => { console.log("Validation errors:", error, form.getValues()); })} className="space-y-2">
            <div className="flex gap-5">


 <FormField
                control={form.control}
                name="Closed"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Open/Live</FormLabel>
                    <FormControl>
                        
                      <Toggle
                        checked={!Boolean(field.value)}
                        onChange={(e) => field.onChange(!e.target.checked)}
                      />
                    
                    </FormControl>
                  </FormItem>
                )}
              />

          <FormField
                control={form.control}
                name="CloseAllowed"
                render={({ field }) => (
                  <FormItem className="w-[12rem]">
                    <FormControl>
                      <Checkbox
                        checked={!!field.value}
                        onCheckedChange={(checked) => field.onChange(checked)}
                        label="Close Allowed (MODERATOR can open/close the chat)"
                      />
                    </FormControl>
                  </FormItem>
                )}
              />
              <FormField
                control={form.control}
                name="Name"
                render={({ field }) => (
                  <FormItem
                  className="flex-1">
                    <FormLabel>Name</FormLabel>
                    <FormControl>
                       <Input {...field} />
                    </FormControl>
                  </FormItem>
                )}
              />
              </div>
              <div className="border-b border-gray-500">Access Rules</div>
            <div className="flex flex-col gap-2">

      <FormField
                control={form.control}
                name="AccessCode"
                render={({ field }) => (
                  <FormItem
                  className="w-[12rem]">
                    <FormLabel>Access Code (Moderator)</FormLabel>
                    <FormControl>
                      <div className="flex items-center gap-2">
                        <Input {...field} />
                        <Button
                                                 type="button"
                                                 variant="ghost"
                                                 size="icon"
                                                 onClick={() => handleGeneratePassword()}
                                                 disabled={isGeneratingPasswordField}
                                                 title="Generate password"
                                               >
                                                 {isGeneratingPasswordField  ? (
                                                   <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />
                                                 ) : (
                                                   <RefreshCw className="h-4 w-4" aria-hidden="true" />
                                                 )}
                                               </Button>
                      </div>
                    </FormControl>
                  </FormItem>
                )}
              />

             
      <FormField
                control={form.control}
                name="IncognitoAllowed"
                render={({ field }) => (
                  <FormItem className="">
                    <FormControl>
                      <Checkbox
                        checked={!!field.value}
                        onCheckedChange={(checked) => field.onChange(checked)}
                        label="Incognito Allowed (if the event is set to shared login without name/media, the user will be redirected to a chat login if incognito is NOT allowed)"
                      />
                    </FormControl>
                  </FormItem>
                )}
              />
             {!form.getValues("IncognitoAllowed") && (
      <FormField
                control={form.control}
                name="FieldMediaRequired"
                render={({ field }) => (
                  <FormItem className="">
                    <FormControl>
                      <Checkbox
                        checked={!!field.value}
                        onCheckedChange={(checked) => field.onChange(checked)}
                        label="Media Required (only takes affect if the Media is not provided on login and Allow Incognito is not turned on for this chat)"
                      />
                    </FormControl>
                  </FormItem>
                )}
              />

             )}
           
              </div>
             
           


            <div className="border-b border-gray-500">Chat Rules</div>
            <div className="flex flex-col gap-2">
             <FormField
                control={form.control}
                name="ShowMessages"
                render={({ field }) => (
                  <FormItem className="">
                    <FormControl>
                      <Checkbox
                        checked={!!field.value}
                        onCheckedChange={(checked) => field.onChange(checked)}
                        label="Show Messages (if not turned on, NO messages will be shown in the chat)"
                      />
                    </FormControl>
                  </FormItem>
                )}
              />
             
             {form.getValues("ShowMessages") && (
              <FormField
                control={form.control}
                name="Alone"
                render={({ field }) => (
                  <FormItem className="">
                    <FormControl>
                      <Checkbox
                        checked={!!field.value}
                        onCheckedChange={(checked) => field.onChange(checked)}
                        label="Alone (Users can only see messages they sent OR have been sent to them directly)"
                      />
                    </FormControl>
                  </FormItem>
                )}
              />

             )}

             <FormField
                control={form.control}
                name="ReplyAllowed"
                render={({ field }) => (
                  <FormItem className="">
                    <FormControl>
                      <Checkbox
                        checked={!!field.value}
                        onCheckedChange={(checked) => field.onChange(checked)}
                        label="Reply Allowed (Users can reply to messages)"
                      />
                    </FormControl>
                  </FormItem>
                )}
              />

              <FormField
                control={form.control}
                name="UploadAllowed"
                render={({ field }) => (
                  <FormItem className="">
                    <FormControl>
                      <Checkbox
                        checked={!!field.value}
                        onCheckedChange={(checked) => field.onChange(checked)}
                        label="Upload Allowed (Users can upload IMAGES)"
                      />
                    </FormControl>
                  </FormItem>
                )}
              />

              <FormField
                control={form.control}
                name="SearchAllowed"
                render={({ field }) => (
                  <FormItem className="">
                    <FormControl>
                      <Checkbox
                        checked={!!field.value}
                        onCheckedChange={(checked) => field.onChange(checked)}
                        label="Search Allowed (Users can search messages)"
                      />
                    </FormControl>
                  </FormItem>
                )}
              />
          </div>

            




            <div className="grid-default">
              <div></div>
              <div className="grid-default">
                <Button className="w-full" type="button" onClick={() => { console.log("Cancel clicked"); onClose(false); }}>Cancel</Button>

                <Button className="w-full" type="submit">Save</Button>
              </div>
            </div>
            {(errorText != "") && (
              <div className="text-red-500 mt-2">
                {errorText}
              </div>
            )
            }
          </form>
        </Form>



       
     
    </div>

  )
}



